import * as React from "react";
import { useTranslation } from "react-i18next";
import { LIST_MODE, NUMBER_MODE } from "views/logic/widgets/events/EventsWidgetConfig";
import EventsList from "views/components/widgets/events/EventsList";
import EventsNumber from "./EventsNumber";
const EventsVisualization = (props) => {
  var _a;
  const { t } = useTranslation("widgets");
  const { config } = props;
  if (config.mode === LIST_MODE) {
    return /* @__PURE__ */ React.createElement(EventsList, { ...props });
  }
  if (config.mode === NUMBER_MODE) {
    return /* @__PURE__ */ React.createElement(EventsNumber, { ...props });
  }
  return /* @__PURE__ */ React.createElement("div", null, t("events_widget.unknown_visualization", { mode: (_a = config.mode) != null ? _a : "undefined" }));
};
export default EventsVisualization;
